import { produce } from 'immer'
import { MailProfileState, MailProfileStateKey } from './MailProfileState'
import { MailProfileType } from './MailProfileType'
import { GlobalType } from '../Global'
export const initialState: MailProfileState = {
  professional: true,
  name: '',
  surname: '',
  phone: null,
  mobile: null,
  email: null,
  company: null,
  siret: null,
  adress1: null,
  adress2: null,
  city: null,
  postal: null,
  site: null,
  logoUrl: null
} as const

export const mailProfileReducer = (state: MailProfileState = initialState, action: MailProfileAction) =>
  produce(state, draft => {
    switch (action.type) {
      case MailProfileType.SAVE_PROFILE: {
        return { ...action.payload.value }
      }
      case MailProfileType.UPDATE_PROFILE: {
        //@ts-ignore
        draft[action.payload.key] = action.payload.value
        return
      }
      case MailProfileType.CLEAN_PROFILE: {
        return { ...initialState }
      }
      case GlobalType.CLEAR_LOADED_DATA:
        return { ...initialState }
    }
  })
export type MailProfileAction =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | { type: MailProfileType.SAVE_PROFILE; payload: { value: MailProfileState } }
  | { type: MailProfileType.UPDATE_PROFILE; payload: { key: MailProfileStateKey; value: string | number | boolean | undefined } }
  | { type: MailProfileType.CLEAN_PROFILE }
